import Box from '@mui/material/Box';
import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useMatch, useNavigation } from 'react-router';
import useWindowSize from '~/hooks/useWindowSize';

const OVERVIEW_TRACK_BG = '#efefef';

export function PageLoadingIndicator() {
  const navigation = useNavigation();
  const { isMobile } = useWindowSize();
  const dashboardMatch = useMatch({
    path: '/:accountType/:accountId/dashboard',
    end: true,
  });
  let trackBackground = 'secondary.main';
  if (dashboardMatch) {
    trackBackground = OVERVIEW_TRACK_BG;
  } else if (isMobile) {
    trackBackground = 'dianomiGrey.main';
  }

  return (
    <Box
      data-testid="page-loading-indicator"
      sx={{
        position: 'relative',
        height: '4px',
        backgroundColor: trackBackground,
      }}
    >
      {navigation.state !== 'idle' && (
        <LinearProgress
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: trackBackground,
            '& .MuiLinearProgress-bar': {
              backgroundColor: 'dianomiGreen.main',
            },
          }}
        />
      )}
    </Box>
  );
}
